import { Avatar, Box, Button, Divider, Grid, ListItem, ListItemIcon, styled, Typography, useMediaQuery } from '@mui/material';
import React, { useState, useEffect, useMemo, useCallback } from 'react'
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import { BsPalette, BsTicketPerforated } from 'react-icons/bs';
import { IoSettingsOutline, IoSparklesOutline } from 'react-icons/io5';
import { TbAward, TbChartBar, TbCreditCard, TbMessage, TbMoneybag, TbMoodSmileBeam,TbRobotFace, TbCash, TbPalette, TbSchool, TbSparkles, TbTag, TbTicket,TbRefresh, TbMessages  } from 'react-icons/tb';
import { HiOutlineChat } from 'react-icons/hi';
import { TfiHelpAlt } from 'react-icons/tfi';
import { MdOutlineFeedback, MdOutlineLogout } from 'react-icons/md';
import { logApiRequest, logUserInteraction } from '../../common/mixpanelInterface';
import axios from 'axios';
import { Switch, FormGroup, FormControlLabel } from '@mui/material';
import SquarePlaceholder from '../../../media/site_media/illustrations/square-placeholder.webp';
import { BsCoin } from 'react-icons/bs';
import { FaChalkboardTeacher } from 'react-icons/fa';
import { FiChevronDown } from 'react-icons/fi';
import { BiNetworkChart } from 'react-icons/bi';
import { IoGlobeOutline } from "react-icons/io5";
import { FaPeopleGroup } from "react-icons/fa6";
import { RiRobot2Line } from "react-icons/ri";
import { MdOutlinePayment } from "react-icons/md";
import TruncateWithEllipsis from '../../common/common/TruncateWithEllipsis';
import { PiChalkboardTeacher } from 'react-icons/pi';
import { GrGroup } from 'react-icons/gr';
import { useNavigate } from 'react-router-dom';
import getImageUrl from '../../../utils/getImageUrl';

const paths = require('../../../paths.json');

const INTERCOM_APP_ID = 'lfsiny3p';

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 36,
  height: 20,
  marginLeft: '20px',
  padding: 0,
  display: 'flex',
  '&:active': {
    '& .MuiSwitch-thumb': {
      width: 20,
    },
    '& .MuiSwitch-switchBase.Mui-checked': {
      transform: 'translateX(7px)',
    },
  },
  '& .MuiSwitch-switchBase': {
    padding: 2,
    '&.Mui-checked': {
      transform: 'translateX(15px)',
      color: '#fff !important',
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: 'var(--brand-color)',
      },
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
    width: 16,
    height: 16,
    borderRadius: 40,
    transition: theme.transitions.create(['width'], {
      duration: 200,
    }),
  },
  '& .MuiSwitch-track': {
    borderRadius: 100,
    opacity: 1,
    backgroundColor:
      theme.palette.mode === 'dark' ? 'rgba(255,255,255,.35)' : 'rgba(0,0,0,.25)',
    boxSizing: 'border-box',
  },
}));

const loadMorePagesFromStorage = () => {
  const stored = localStorage.getItem('morePages');
  if (stored) {
    return JSON.parse(stored);
  }
  return [{
    promo_codes: true,
    referrals: true,
    branding: true,
    examples: true,
  }];
};

const MoreMenuItems = ({ setState, handleProfileTabChange, updateViewType, view_type, activeProductData, launchHelp, ...props }) => {
  const navigate = useNavigate();
  const isDesktop = useMediaQuery('(min-width:1280px)');
  const [showLogout, setShowLogout] = useState(false);
  const [morePages, setMorePages] = useState(props.morePages || loadMorePagesFromStorage());
  const [priorityTab, setPriorityTab] = useState(null);
  
  const handleTabChange = (tab) => {
    navigate(`?page=${tab}`);
    window.scrollTo({ top: 0, behavior: 'instant' });
  };
  const menuItems = useMemo(() => [
    {
      id: 'insights',
      title: 'Insights',
      description: '',
      icon: TbChartBar,
      comingSoon: false,
      mobile_only: true,
      toggle: null,
      action: () => handleTabChange('insights'),
      condition: true,
    },
    {
      id: 'payouts',
      title: 'Payouts',
      description: '',
      icon: TbCash,
      comingSoon: false,
      mobile_only: true,
      toggle: null,
      action: () => handleTabChange('payouts'),
      condition: true,
    },
    {
      id: 'customers',
      title: 'Customers',
      description: '',
      icon: TbMoodSmileBeam,
      comingSoon: false,
      mobile_only: true,
      toggle: null,
      action: () => handleTabChange('customers'),
      condition: true,
    },
    {
      id: 'subscriptions',
      title: 'Subscriptions',
      description: '',
      icon: TbRefresh,
      comingSoon: false,
      mobile_only: true,
      toggle: null,
      action: () => {
        handleTabChange('subscriptions')
      },
      condition: activeProductData?.active_products?.[0]?.subscriptions?.active
    },
    {
      id: 'digital_products',
      title: 'Digital Products',
      description: '',
      icon: TbAward,
      comingSoon: false,
      mobile_only: true,
      toggle: null,
      action: () => {
        handleTabChange('digital_products')
      },
      condition: activeProductData?.active_products?.[0]?.digitalproducts?.active
    },
    {
      id: 'courses',
      title: 'Courses',
      description: '',
      icon: TbSchool,
      comingSoon: false,
      mobile_only: true,
      toggle: null,
      action: () => {
        handleTabChange('courses')
      },
      condition: activeProductData?.active_products?.[0]?.courses?.active
    },
    {
      id: '1v1coaching',
      title: '1:1 Coaching',
      description: '',
      icon: TbMessages,
      comingSoon: false,
      mobile_only: true,
      toggle: null,
      action: () => {
        handleTabChange('1v1coaching')
      },
      condition: activeProductData?.active_products?.[0]?.oneOnOneCoaching?.active
    },
    {
      id: 'community',
      title: 'Community',
      description: '',
      icon: GrGroup,
      comingSoon: false,
      mobile_only: true,
      toggle: null,
      action: () => {
        handleTabChange('community')
      },
      condition: activeProductData?.active_products?.[0]?.community?.active
    },
    {
      id: 'messages',
      title: 'Messages',
      description: '',
      icon: TbMessage,
      comingSoon: false,
      mobile_only: true,
      toggle: null,
      action: () => {
        handleTabChange('messages')
      },
      condition: activeProductData?.active_products?.[0]?.messages?.active
    },
    {
      id: 'promo_codes',
      title: 'Promo Codes',
      description: 'Create and manage promotional codes.',
      icon: TbTicket,
      comingSoon: false,
      mobile_only: false,
      toggle: morePages?.[0]?.promo_codes === true,
      action: () => handleTabChange('promo_codes'),
      condition: true,
    },
    {
      id: 'branding',
      title: 'Branding',
      description: 'Customize your brand with your own logo and colors.',
      icon: TbPalette,
      comingSoon: false,
      mobile_only: false,
      toggle: morePages?.[0]?.branding === true,
      action: () => handleTabChange('branding'),
      condition: true,
    },
    {
      id: 'examples',
      title: 'Creator Inspo',
      description: 'Get inspired by other creators and learn from their success.',
      icon: TbSparkles,
      comingSoon: false,
      mobile_only: false,
      toggle: morePages?.[0]?.examples === true,
      action: () => handleTabChange('examples'),
      condition: true,
    },
    {
      id: 'referrals',
      title: 'Referrals',
      description: 'Earn passive income by referring WithMe.',
      icon: TbMoneybag,
      comingSoon: false,
      mobile_only: false,
      toggle: morePages?.[0]?.referrals === true,
      action: () => handleTabChange('referrals'),
      condition: true,
    },
    {
      id: 'domains',
      title: 'Domains',
      description: 'Use your own domain name.',
      icon: IoGlobeOutline,
      comingSoon: false,
      applyForEarlyAccess: true,
      mobile_only: false,
      action: () => launchHelp(),
      condition: true,
    },
    {
      id: 'marketing',
      title: 'Email Marketing',
      description: 'Send targeted emails to your audience.',
      icon: BiNetworkChart,
      comingSoon: false,
      applyForEarlyAccess: true,
      mobile_only: false,
      action: () => launchHelp(),
      condition: true,
    },
    {
      id: 'affiliates',
      title: 'Affiliates',
      description: 'Allow others to sell your products and be rewarded.',
      icon: FaPeopleGroup,
      comingSoon: true,
      mobile_only: false,
      action: () => handleTabChange('affiliates'),
      condition: true,
    }
  ], [morePages, updateViewType, setState, handleProfileTabChange, view_type, activeProductData, launchHelp]);

  const getPriorityTab = () => {
    if (activeProductData && activeProductData.active_products && activeProductData.active_products.length > 0) {
      const products = activeProductData.active_products[0];

      const priorityOrder = [
        'subscriptions',
        'oneOnOneCoaching', 
        'community',
        'digitalproducts',
        'courses',
        'messages'
      ];
      
      // Check each product type in priority order
      for (const productType of priorityOrder) {
        
        if (productType === 'subscriptions' && products.subscriptions?.active) {
          setPriorityTab(productType);
          break;
        }
        if (productType === 'oneOnOneCoaching' && products.oneOnOneCoaching?.active) {
          setPriorityTab('1v1coaching');
          break;
        }
        if (productType === 'community' && products.community?.active) {
          setPriorityTab(productType);
          break;
        }
        if (productType === 'digitalproducts' && products.digitalproducts?.active) {
          setPriorityTab('digital_products');
          break;
        }
        if (productType === 'courses' && products.courses?.active) {
          setPriorityTab(productType);
          break;
        }
        if (productType === 'messages' && products.messages?.active) {
          setPriorityTab(productType);
          break;
        }
      }
    }
  };

  useEffect(() => {
    getPriorityTab()
    if (props.morePages) {
      setMorePages(props.morePages);
    } else {
      setMorePages(loadMorePagesFromStorage());
    }
  }, [props.morePages]);

  const handleToggle = useCallback((itemId, event) => {
    if (event) {
      event.stopPropagation();
    }
    const currentState = morePages?.[0] || {
      promo_codes: true,
      branding: true,
      examples: true,
      referrals: true,
    };

    const newState = { ...currentState, [itemId]: !currentState[itemId] };
    const newMorePages = [newState];

    localStorage.setItem('morePages', JSON.stringify(newMorePages));

    setMorePages(newMorePages);

    if (setState) {
      setState((prev) => ({ ...prev, morePages: newMorePages }));
    }
  }, [morePages, setState]);

  const handleItemClick = useCallback((item) => {
    if (item.comingSoon || item.applyForEarlyAccess) {
      item.action();
      return;
    }
    
    if (item.toggle !== undefined) {
      handleToggle(item.id);
    }
    
    if (item.action) item.action();
  }, [handleToggle]);

  const logoutProcess = useCallback(() => {
    const startTime = performance.now();
    axios({
      method: 'GET',
      url: paths.BACKEND_URL + "api/logout",
      withCredentials: true
    }).finally(() => {
      logApiRequest(paths.BACKEND_URL + 'api/logout', performance.now() - startTime);
      logUserInteraction('Logout');
      window.Intercom('shutdown');
      window.location.assign("/");
    });
  }, []);

  return (
    <>
      {isDesktop ? (
        <Grid container spacing={4} rowSpacing={4}>

          {menuItems.filter(item => item.mobile_only === false).map((item) => (
            <Grid item xs={12} md={6} key={item.id}>
              <Box
                sx={{
                  border: '1px solid #E4EBF6',
                  borderRadius: '8px',
                  padding: '20px',
                  position: 'relative',
                  backgroundColor: item.comingSoon ? '#f8f9fa' : '#fff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: item.comingSoon ? 'normal' : (item.applyForEarlyAccess ? 'flex-start' : 'space-between'),
                  opacity: item.comingSoon ? 0.8 : 1,
                  pointerEvents: item.comingSoon ? 'none' : 'auto',
                  
                }}
       
              >
                {item.comingSoon && (
                  <Box
                    sx={{
                      position: 'absolute',
                      top: '10px',
                      right: '10px',
                      backgroundColor: '#9CA3B3',
                      color: 'white',
                      padding: '4px 8px',
                      borderRadius: '4px',
                      fontSize: '12px',
                      fontWeight: 500,
                      zIndex: 400,
                    }}
                  >
                    Coming Soon
                  </Box>
                )}

                {item.applyForEarlyAccess && (
                  <Box
                    sx={{
                      position: 'absolute',
                      top: '10px',
                      right: '10px',
                      backgroundColor: 'var(--brand-color)',
                      color: 'white',
                      cursor: 'pointer',
                      padding: '4px 8px',
                      borderRadius: '4px',
                      fontSize: '12px',
                      fontWeight: 500,
                      zIndex: 400,
                    }}
                    onClick={() => item.action()}
                  >
                    {window.innerWidth < 768 ? 'Early Access' : 'Message for Early Access'}
                  </Box>
                )}

                <Box
                onClick={() => {
                  if (item.comingSoon) {
                    item.action();
                  } else {
                    if (item.toggle === false) {
                      handleToggle(item.id)
                    }
                    item.action();
                  }
                }}
                  sx={{
                    width: '100px',
                    height: '100px',
                    minWidth: '100px',
                    minHeight: '100px',
                    marginRight: '20px',
                    borderRadius: '8px',
                    // backgroundImage: `url(${SquarePlaceholder})`,
                    backgroundColor: 'var(--rebranding-content-background-light)',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    position: 'relative',
                    cursor: item.comingSoon ? 'default' : 'pointer',
                  }}
                >
                  <item.icon style={{ color: '#222222', fontSize: '36px', margin: 'auto', zIndex: 300 }} />
                  <Box
                    sx={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                      backgroundColor: '#EFF4FC',
                      // backgroundColor: 'rgba(0, 0, 0, 0.03)',
                      borderRadius: '8px',
                      zIndex: 100,
                    }}
                  />

                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'column', textAlign: 'left' }}>
                  <p 
                           onClick={() => {
                            if (item.comingSoon) {
                              item.action();
                            } else {
                              if (item.toggle === false) {
                                handleToggle(item.id)
                              }
                              item.action();
                            }
                          }}
                  style={{
                    fontSize: '18px',
                    fontWeight: 700,
                    color: "#1f2937",
                    margin: "5px 0px 0px 0px",
                    cursor: item.comingSoon ? 'default' : 'pointer',
                  }}>
                    {item.title}
                  </p>
                  <p style={{ marginTop: '8px', fontSize: '14px', color: '#6E89AF', marginBottom: '10px', fontWeight: '500', lineHeight: '1.4' }}>
                    {item.description}
                  </p>
                </Box>
                {!item.comingSoon && !item.applyForEarlyAccess && (
                  <Box sx={{ display: 'flex', alignItems: 'center', marginLeft: 'auto', zIndex: 1, height: '30px' }}>
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <AntSwitch
                            checked={item.toggle}
                            onChange={(event) => {
                              event.stopPropagation();
                              handleToggle(item.id, event)
                            }}
                          />
                        }
                        label={<></>}
                        labelPlacement="start"
                        onClick={(e) => e.stopPropagation()}
                      />
                    </FormGroup>
                  </Box>
                )}
              </Box>
            </Grid>
          ))}
        </Grid>
      ) : (
        <Box
          sx={{
            width: 'calc(100% - 40px)',
            minHeight: 'calc(100% - 200px)',
            display: 'flex',
            flexDirection: 'column',
            gap: '20px',
            width: '100%',
            pointerEvents: 'auto',
            userSelect: 'none',
            borderRadius: '0px',
            alignContent: 'flex-start',
            zIndex: 1002,
          }}
        >
          <Grid container spacing={2} sx={{ marginBottom: '10px', maxWidth: { xs: '600px', lg: '100%'}, mx: { sm: 'auto' } }}>
            {menuItems.map((item) => (
              item.condition && item.id !== priorityTab && 
              (props.launched_influencer === true && item.id === 'insights' ? null :
              <Grid item xs={window.innerWidth < 370 ? 6 : 3} sm={3} md={3} key={item.id}>
                <Box
                  onClick={() => {
                    if (item.comingSoon) {
                      item.action();
                      return;
                    } else {
                      handleItemClick(item);
                    }
                  }}
                  sx={{
                    borderRadius: '8px',
                    position: 'relative',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: '5px',
                    cursor: item.comingSoon ? 'default' : 'pointer',
                    opacity: item.comingSoon ? 0.8 : 1,
                    pointerEvents: item.comingSoon ? 'none' : 'auto',
                    backgroundColor: item.comingSoon ? '#f8f9fa' : '#F5F9FF',
                    filter: item.comingSoon ? 'grayscale(50%)' : 'none',
                    overflow: 'hidden',
                    '&:hover': {
                      backgroundColor: item.comingSoon ? '#f8f9fa' : '#F5F9FF',
                    }
                  }}
                >
                  {item.comingSoon && (
                    <Box
                      sx={{
                        position: 'absolute',
                        top: 0,
                        right: 0,
                        backgroundColor: '#9CA3B3',
                        color: 'white',
                        padding: { xs: '2px 4px 4px 6px', md: '4px 8px' },
                        borderBottomLeftRadius: '4px',
                        fontSize: '10px',
                        fontWeight: 500,
                        zIndex: 400,
                      }}
                    >
                      Coming Soon
                    </Box>
                  )}
                  {item.applyForEarlyAccess && (
                    <Box
                      sx={{
                        position: 'absolute',
                        top: 0,
                        right: 0,
                        cursor: 'pointer',
                        backgroundColor: 'var(--brand-color)',
                        color: 'white',
                        padding: { xs: '2px 4px 4px 6px', md: '4px 8px' },
                        borderBottomLeftRadius: '4px',
                        fontSize: '10px',
                        fontWeight: 500,
                        zIndex: 400,
                      }}
                      onClick={() => item.action()}
                    >
                      {window.innerWidth < 1280 ? 'Early Access' : 'Message for Early Access'}
                    </Box>
                  )}
                  <Box
                    sx={{
                      width: '100%',
                      aspectRatio: '1',
                      borderRadius: '8px',
                      // backgroundImage: `url(${SquarePlaceholder})`,
                      backgroundColor: 'var(--rebranding-content-background-light)',
                      backgroundSize: 'cover',
                      backgroundPosition: 'center',
                      boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.05)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      position: 'relative',
                    }}
                  >
                    <Box sx={{ fontSize: { xs: '25px', md: '40px' },  lineHeight: '20px', margin: 'auto', zIndex: 300 }}>
                      <item.icon style={{ color: '#000' }} />
                    </Box>
                    <Box
                      sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: '#E1E9F6',
                        borderRadius: '8px',
                        zIndex: 100,
                      }}
                    />
                  </Box>
                  <Typography variant="body1" sx={{ fontWeight: 700, color: '#1f2937', fontSize: window.innerWidth < 768 ? (window.innerWidth < 370 ? '11px' : '12px') : '16px', textAlign: 'center' }}>
                    {item.title}
                  </Typography>
                </Box>
              </Grid>)
            ))}
          </Grid>

          <Grid xs={12} sm={12} md={12} lg={12} sx={{
            margin: '0px auto 40px auto',
            boxSizing: 'border-box',
            // border: '1px solid #E4EBF6',
            fontFamily: 'Roboto',
            borderRadius: '8px',
            // backgroundColor: '#F5F9FF',
            height: 'auto',
            width: '100%',
          }}>
            {/* More Section */}
            <Typography variant="body1" sx={{ 
              fontSize: '16px', 
              fontWeight: 600, 
              color: '#222222',
              padding: '0px 0px 0px',
              marginTop: '20px',
            }}>
              More
            </Typography>

            {/* {props.launched_influencer === false && (
              <Box sx={{
                backgroundColor: '#fff',
                borderBottom: '1px solid #E4EBF6',
              }}>
                <Box onClick={() => props.handlePricingModalOpen()} sx={{
                  display: 'flex',
                  alignItems: 'center',
                  width: '100%',
                  gap: '10px',
                  cursor: 'pointer',
                  boxSizing: 'border-box',
                  padding: '15px 20px',
                  '&:hover': {
                    backgroundColor: '#F5F9FF',
                  }
                }}>
                  <TbTag style={{ height: '16px', width: '16px', color: '#1D1D1D' }} />
                  <Typography variant="body1" sx={{ fontSize: '15px', fontWeight: 500 }}>
                    Pricing
                  </Typography>
                </Box>
              </Box>
            )} */}

              <Box 
              onClick={() => window.Intercom('show')}
              sx={{
                backgroundColor: '#fff',
                border: '1px solid #E4EBF6',
                borderRadius: '8px',
                marginTop: '10px',
                display: 'flex',
                alignItems: 'center',
                padding: '15px 20px 15px 15px',
                gap: '10px',
                cursor: 'pointer',
                '&:hover': {
                  backgroundColor: '#fff',
                },
                '&:active': {
                  backgroundColor: '#fff',
                }
              }}>
                <Box sx={{
                  width: '25px',
                  height: '25px',
                  minWidth: '25px',
                  borderRadius: '50%',
                  backgroundColor: 'var(--brand-color)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}>
                  <TbRobotFace style={{ color: '#fff', fontSize: '15px' }} />
                </Box>
                <Typography variant="body1" sx={{ fontSize: '15px', fontWeight: 500 }}>
                  Ask WithMe
                </Typography>
              </Box>

            <Box sx={{
                  backgroundColor: '#fff',
                  border: '1px solid #E4EBF6',
                  borderRadius: '8px',
                  marginTop: '10px',
            }}>
              <Box onClick={() => handleTabChange('settings')} sx={{
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                gap: '10px',
                cursor: 'pointer',
                boxSizing: 'border-box',
                padding: '15px 20px',
                '&:hover': {
                  backgroundColor: '#fff',
                },
                '&:active': {
                  backgroundColor: '#fff',
                }
              }}>
                <IoSettingsOutline style={{ height: '16px', width: '16px', color: '#1D1D1D' }} />
                <Typography variant="body1" sx={{ fontSize: '15px', fontWeight: 500 }}>
                  Settings
                </Typography>
              </Box>
            </Box>

            {/* Account Section */}
            <Typography variant="body1" sx={{ 
              fontSize: '16px', 
              fontWeight: 600, 
              color: '#222222',
              padding: '0px 0px 0px',
              marginTop: '20px',
            }}>
              Account
            </Typography>

            <Box sx={{
                   backgroundColor: '#fff',
                   border: '1px solid #E4EBF6',
                   borderRadius: '8px',
                   marginTop: '10px',
                   overflow: 'hidden',
            }}>
              <Button
                sx={{
                  width: '100%',
                  margin: '0px auto 0px',
                  backgroundColor: '#ffffff',
                  color: '#000',
                  padding: '15px 20px',
                  borderRadius: showLogout ? '0' : '0 0 8px 8px',
                  boxSizing: 'border-box',
                  outline: 'none',
                  display: 'flex',
                  fontSize: '15px',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  textTransform: 'capitalize',
                  '&:hover': {
                    backgroundColor: '#fff',
                  },
                  '&:active': {
                    backgroundColor: '#fff',
                  }
                }}
                onClick={() => setShowLogout(!showLogout)}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <Avatar alt="" src={getImageUrl(props.iconImage)} sx={{ width: '30px', height: '30px' }} />
                  <Typography variant="body1" sx={{ fontWeight: 500 }}>
                    {TruncateWithEllipsis(props.display_name, 20)}
                  </Typography>
                </Box>
                <FiChevronDown style={{
                  color: "#6E89AF",
                  fontSize: '15px',
                  transform: showLogout ? "rotate(180deg)" : "rotate(0deg)",
                  transition: 'transform 0.2s'
                }} />
              </Button>

              {showLogout && (
                <Box onClick={() => logoutProcess()} sx={{
                  display: 'flex',
                  alignItems: 'center',
                  width: '100%',
                  boxSizing: 'border-box',
                  gap: '10px',
                  cursor: 'pointer',
                  padding: '15px 20px',
                  borderRadius: '0 0 8px 8px',
                  '&:hover': {
                    backgroundColor: '#F5F9FF',
                  }
                }}>
                  <MdOutlineLogout style={{ height: '16px', width: '16px', color: '#1D1D1D' }} />
                  <Typography variant="body1" sx={{ fontSize: '15px', fontWeight: 500 }}>
                    Log Out
                  </Typography>
                </Box>
              )}
            </Box>
          </Grid>
        </Box>
      )}
    </>
  )
}

export default MoreMenuItems